import { render, staticRenderFns } from "./ExercisesTableTest.vue?vue&type=template&id=23000eb6&scoped=true&"
import script from "./exercisestableTest.js?vue&type=script&lang=js&"
export * from "./exercisestableTest.js?vue&type=script&lang=js&"
import style0 from "./ExercisesTableTest.vue?vue&type=style&index=0&id=23000eb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23000eb6",
  null
  
)

export default component.exports